import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { useFetchProfilesQuery, useFetchCollegesQuery } from '../../store/api/apiSlice';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const { data: profileData } = useFetchProfilesQuery();
  const { data: universitiesData } = useFetchCollegesQuery();
  const collegeList = universitiesData?.university || [];
  const matchedCollege = collegeList.find(college => college.name === profileData?.user?.school_name);
  const storedFgColor = profileData?.user?.customForeground ;
  const storedBgColor = profileData?.user?.customBackground ;

  const [theme, setTheme] = useState({
    fgColor: '255, 255, 255', // Default foreground color
    bgColor: '112, 79, 230', // Default background color
    secondaryColor: '#ccc', // Default secondary color
  });

  useEffect(() => {
   

    if (storedFgColor && storedBgColor) {
      // If colors are found in local storage, use them
      setTheme({
        fgColor: `rgb(${storedFgColor})`,
        bgColor: `rgb(${storedBgColor})`,
        secondaryColor: '#ccc', // You can set this to a default or another stored value if needed
      });
    } else if (!storedFgColor && !storedBgColor && matchedCollege) {
      const fgColor = matchedCollege.fg_color_code || theme.fgColor;// Fallback to black
      const bgColor = matchedCollege.bg_color_code || theme.bgColor; // Fallback to white
      const secondaryColor = matchedCollege.secondary_color_code || '204, 204, 204'; // Fallback to gray
      const isRgbFormat = /^(\d{1,3},\s*\d{1,3},\s*\d{1,3})$/.test(bgColor);
      const isNamedColor = /^[a-zA-Z]+$/.test(bgColor);
      document.documentElement.style.setProperty('--bg-color', bgColor);
      setTheme({
        fgColor: isRgbFormat ? `rgb(${fgColor})` : 'rgb(255, 255, 255)',
        bgColor: isRgbFormat ? `rgb(${bgColor})` : `rgb(112, 79, 230)`,
        secondaryColor: `rgb(${secondaryColor})`,
      });
    }
  }, [matchedCollege]);

  useEffect(() => {
    document.documentElement.style.setProperty('--fg-color', theme.fgColor);

    document.documentElement.style.setProperty('--secondary-color', theme.secondaryColor);
  }, [theme]);
  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  return useContext(ThemeContext);
};